module.exports = __webpack_public_path__ + "img/perforaciones_9-16_360.f3436c0d.jpg";